import { Instagram, MapPin, Phone, Mail, Clock } from "lucide-react";
import { useI18n } from "../i18n";

const TikTok = (props) => (
  <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20" {...props}>
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5 20.1a6.34 6.34 0 0 0 10.86-4.43v-7a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1-.1z" />
  </svg>
);

export const Footer = () => {
  const { t } = useI18n();
  return (
    <footer data-testid="footer" className="relative bg-[#050505] pt-24 pb-10 px-6 md:px-10 border-t border-cyan-500/10">
      <div className="max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 pb-16">
          <div className="md:col-span-5">
            <div className="flex items-center gap-5">
              <img
                src="/logo-wrappman.png"
                alt="Wrapp Man logo"
                className="h-20 w-20 md:h-24 md:w-24 rounded-full object-cover ring-1 ring-cyan-500/40"
              />
              <h3 className="font-display font-900 uppercase tracking-tighter text-4xl md:text-5xl">
                Wrapp<span className="text-cyan">.</span>Man
              </h3>
            </div>
            <p className="text-neutral-400 font-light mt-5 max-w-sm">{t("footer.blurb")}</p>
            <div className="flex gap-3 mt-7">
              <a data-testid="social-instagram" href="https://instagram.com/wrapp_man" target="_blank" rel="noopener noreferrer" className="h-11 w-11 rounded-full border border-white/10 flex items-center justify-center hover:border-cyan-400 hover:text-cyan transition-colors duration-300">
                <Instagram size={20} />
              </a>
              <a data-testid="social-tiktok" href="https://tiktok.com" target="_blank" rel="noopener noreferrer" className="h-11 w-11 rounded-full border border-white/10 flex items-center justify-center hover:border-cyan-400 hover:text-cyan transition-colors duration-300">
                <TikTok />
              </a>
            </div>
          </div>

          <div className="md:col-span-4">
            <span className="font-mono-accent text-xs uppercase tracking-[0.25em] text-cyan">{t("footer.contact")}</span>
            <ul className="mt-6 space-y-4 text-neutral-300 font-light">
              <li className="flex items-center gap-3">
                <MapPin size={18} className="text-cyan shrink-0" /> Saint-Martin 97150
              </li>
              <li className="flex items-center gap-3">
                <Phone size={18} className="text-cyan shrink-0" />
                <a href="tel:+590690664414" className="hover:text-cyan transition-colors">+590 690 66 44 14</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={18} className="text-cyan shrink-0" />
                <a href="mailto:Wrappmansxm@outlook.fr" className="hover:text-cyan transition-colors">Wrappmansxm@outlook.fr</a>
              </li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <span className="font-mono-accent text-xs uppercase tracking-[0.25em] text-cyan">{t("footer.hours")}</span>
            <ul className="mt-6 space-y-3 text-neutral-300 font-light">
              <li className="flex items-start gap-3">
                <Clock size={18} className="text-cyan shrink-0 mt-1" />
                <div>
                  <div>{t("footer.week")}</div>
                  <div>{t("footer.sat")}</div>
                  <div className="text-neutral-500">{t("footer.sun")}</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4 text-neutral-600 text-sm font-light">
          <span>© {new Date().getFullYear()} Wrapp Man. {t("footer.rights")}</span>
          <span className="font-mono-accent text-xs uppercase tracking-[0.2em]">{t("footer.tagline")}</span>
        </div>

        <div
          data-testid="prelaunch-footer-notice"
          className="mt-6 flex items-center justify-center gap-2 text-center font-mono-accent text-[11px] uppercase tracking-[0.25em] text-cyan/80"
        >
          <span className="relative inline-flex h-1.5 w-1.5">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-cyan-400 opacity-60" />
            <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-cyan-400" />
          </span>
          {t("preLaunch.footerNotice")}
        </div>
      </div>
    </footer>
  );
};
